import axios from 'axios'

export default {
    updateChild(child) {
        return axios.put('child/' + child.id, child).then(response => {
            return response.data
        })
    },

    createChild(child) {
        return axios.post('child', child).then(response => {
            return response.data
        })
    },

    deleteChild(id) {
        return axios.delete('child/' + id).then(response => {
            return response.data
        })
    },

    fetchChild(id) {
        return axios.get('child/' + id)
            .then(response => {
                return response.data
            })
    },

    fetchChildes() {
        return axios.get('child').then(response => {
            return response.data
        })
    },
}
